module.exports = __webpack_public_path__ + "img/mnz.75f46eec.svg";